import { Space } from 'antd';
import { ColumnType } from '@/types';
import { DeleteButton } from '@/components/buttons/delete';
import { DeleteOutlined } from '@ant-design/icons';
import { EditButton } from '@refinedev/antd';

export const getColumnsEmbedPlatforms = (
  translate: (key: string) => string,
  handleDeleteEmbedPlatform: () => void,
  setEmbedPlatformToDelete: (platform: string) => void,
  setEmbedPlatformToEdit: (platform: string) => void,
  setIsEditEmbedPlatformModalOpen: (open: boolean) => void,
  adminType?: string
): ColumnType[] => [
  {
    title: translate('system-config.embed-platforms.id'),
    key: 'id',
    dataIndex: 'id',
    render: (_, record, index) => index + 1,
  },
  {
    title: translate('system-config.embed-platforms.name'),
    dataIndex: 'allowed_embed_platforms',
    key: 'allowed_embed_platforms',
    render: (_, record) => record,
  },
  ...(adminType === 'SUPER_ADMIN'
    ? [
        {
          title: translate('system-config.embed-platforms.actions'),
          dataIndex: 'actions',
          key: 'actions',
          //@ts-ignore
          render: (_, record) => (
            <Space>
              <EditButton
                hideText
                size="small"
                onClick={() => {
                  setEmbedPlatformToEdit(record);
                  setIsEditEmbedPlatformModalOpen(true);
                }}
              />
              <DeleteButton
                icon={<DeleteOutlined />}
                hideText
                size="small"
                recordItemId={record}
                confirmTitle={translate(
                  'system-config.embed-platforms.delete-confirm'
                )}
                onClick={() => setEmbedPlatformToDelete(record)}
                onConfirm={() => handleDeleteEmbedPlatform()}
              />
            </Space>
          ),
        },
      ]
    : []),
];
